/**
 * Browser transport for the HTTP provider. It reuses `apiClient` so the
 * session cookie, JSON handling and the 401 / membership-disabled redirects
 * are the same as every other page. Kept out of the unit tests (they inject a
 * mock transport) because `apiClient` is a browser module.
 */
import { ApiError, apiRequest } from '../../../lib/apiClient.js';
import type { AiTransport } from './httpProvider.ts';

export const fetchTransport: AiTransport = async ({ method, path, body, headers, signal }) => {
  try {
    const parsed = await apiRequest<unknown>(path, {
      method,
      signal,
      ...(body !== undefined ? { body } : {}),
      ...(headers ? { headers: { ...headers } } : {}),
    });
    return { status: 200, body: parsed };
  } catch (error) {
    if (error instanceof ApiError) return { status: error.status, body: error.envelope };
    // Body was not JSON: report a 200 with no body so validation rejects it.
    if (error instanceof SyntaxError) return { status: 200, body: undefined };
    throw error;
  }
};
